import API_MAPS_SERVICES from "../modules/API/api_services_maps";
import SETCOORDS from "../modules/API/set_coords";
SETCOORDS();
/*

    Summary
        0 - Functions
        1 - Initial Config
        2 - Init Map

*/

/*---------------------- 0 - Functions -------------------*/
function getAddressesAssistance() {
    const mainDivId = '#page-maps-assistance';

    let addressesObj = $.ajax({
        type: "POST",
        url: $(mainDivId).attr('adressesRoute'),
        data: "",
        dataType: "json",
        headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
    }).done(() => {
        const allAddress = addressesObj.responseJSON;
        const idForms = '#search-assistance'
        const mapId = 'map--assistance'
        const type = 'assistance'
        const pathMarkerAssistance = document.getElementById('pin-markerServices').dataset.image
        const messageRefence = 'as assistências'
        const messageNotFound = 'Não encontramos assistências próximas a você, iremos filtrar aonde você encontrará a assistência mais próxima!'

        API_MAPS_SERVICES(
            allAddress,
            mapId, idForms,
            pathMarkerAssistance,
            type,
            messageRefence, messageNotFound,
            mainDivId
        );
    });

}

/*---------------------- 1 - Initial Config -------------------*/
const socialIcons = document.getElementById('component--social-icons')
socialIcons.style.display = 'none'

const header = document.querySelector('header')
header.classList.add("maps-page")

const footer = document.querySelector('footer')
footer.classList.add("maps-page")

document.documentElement.style.setProperty('--zoom', 1);

/*----------------------  2 - Init Map -------------------*/
window.onload = () => {
    getAddressesAssistance()
}
